import { render, staticRenderFns } from "./AssignmentEquipment.vue?vue&type=template&id=688b3b98&"
import script from "./AssignmentEquipment.vue?vue&type=script&lang=js&"
export * from "./AssignmentEquipment.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentEquipment.vue?vue&type=style&index=0&id=688b3b98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports